<template>
    <div class="container-fluid">
        <template>
            <div class="card card-box">
                <div class="card-body card-bg">
                    <b-row>
                        <b-col>
                            <p class="text-capitalize my-2 font-weight-bold f-20">upload data obat anda sebelumnya</p>
                        </b-col>
                        <b-col class="pull-right">
                            <p class="text-uppercase my-2 font-weight-bold f-20 float-right">
                                <router-link
                                    class="a-color"
                                    :to="{
                                        name: 'klinik-obat-list'
                                    }"
                                >
                                    tutup
                                </router-link>
                            </p>
                        </b-col>
                    </b-row>
                </div>
            </div>
            <div class="mt-4">
                <ol>
                    <li>Download template dengan menekan tombol <b>'Download template'</b></li>
                    <li>Isi data Anda sesuai template yang sudah didownload, <span class="text-danger">maksimal 500 data!</span></li>
                    <li>Upload kembali data Anda sesuai template dengan klik <b>'Upload File'</b> lalu klik 'Open'</li>
                    <li>Tunggu hingga data Anda berhasil disimpan!</li>
                </ol>
            </div>
            <b-button
                class="text-capitalize btn-download mb-4 ml-3"
                @click="downloadTemplate"
            >
                <font-awesome-icon icon="download"/>
                download template
            </b-button>
            <div class="ml-3">
                <form enctype="multipart/form-data">
                    <b-media>
                        <template #aside>
                            <div class="upload-btn-wrapper">
                                <b-button class="text-capitalize btn-file">
                                    upload file
                                </b-button>
                                <input type="file" ref="fileupload" @change="fileChange"/>
                            </div>
                        </template>
                        <p class="mb-0">
                            <small class="f-12"><i>{{ fileText }}</i></small>
                        </p>
                    </b-media>
                    <small class="f-9"><i>format yang digunakan: xls, xlsx.</i></small>
                </form>
            </div>
        </template>

        <template>
            <div class="card card-box my-4">
                <div class="card-body card-bg">
                    <p class="text-uppercase my-2 font-weight-bold f-20 text-center">cara pengisian template</p>
                </div>
            </div>

            <div class="table-responsive">
                <b-table
                    striped
                    :items="items"
                    :fields="fieldList"
                    :borderless="true"
                    sticky-header="500px"
                >
                    <template #cell(aturan_penulisan)="data">
                        <span v-html="data.value"></span>
                    </template>
                </b-table>
            </div>
        </template>

        <template v-if="progressBar">
            <b-modal
                :no-close-on-backdrop="true"
                :no-close-on-esc="true"
                :cancel-disabled="true"
                ref='modal-obat'
                style="color:#d3e8eb;"
                hide-footer
                hide-header
                centered
                size="lg"
                class="__modalll"
            >
                <b-row>
                    <b-col>
                        <small>Your Progress</small>
                        <h5 class="my-3"><b>{{ barVal }}% to Complete</b></h5>
                    </b-col>
                    <b-col class="align-self-end my-3 text-right">
                        <font-awesome-icon icon="clock"/>
                        <small class="ml-2">{{ time }} min</small>
                    </b-col>
                </b-row>
                <b-progress :max="barMax">
                    <b-progress-bar
                        :value="barVal"
                    ></b-progress-bar>
                </b-progress>
                <b-row class="float-right">
                    <b-col>                        
                        <small class="text-danger"><b>Mohon untuk tidak menutup halaman ini. Data Anda sedang diproses.</b></small>
                    </b-col>
                </b-row>
            </b-modal>
        </template>
    </div>
</template>

<script>
    
    import startCase from "lodash/startCase";
    import { library } from "@fortawesome/fontawesome-svg-core";
    import { faDownload, faClock } from "@fortawesome/free-solid-svg-icons";
    import { mapGetters } from 'vuex';

    library.add(faDownload, faClock);

    export default {
        data() {
            return {
                fileText: "No file selected.",
                fileObat: null,
                file: null,
                items: [
                    {
                        nama_kolom: "KODE OBAT",
                        keterangan: "WAJIB DIISI",
                        maksimal_karakter: "10 Karakter",
                        aturan_penulisan: "Terdiri dari huruf, angka, dan - <br> Contoh : A-00029, A092190"
                    },
                    {
                        nama_kolom: "NAMA OBAT",
                        keterangan: "WAJIB DIISI",
                        maksimal_karakter: "100 Karakter",
                        aturan_penulisan: "Terdiri dari huruf dan angka. Dapat menggunakan simbol. <br> Contoh: Paracetamol 500mg (Tab)"
                    },
                    {
                        nama_kolom: "KATEGORI",
                        keterangan: "WAJIB DIISI",
                        maksimal_karakter: "50 Karakter",
                        aturan_penulisan: "Terdiri dari huruf <br> Hanya boleh diisi dengan jenis obat yang terdaftar dilist"
                    },
                    {
                        nama_kolom: "JENIS",
                        keterangan: "WAJIB DIISI",
                        maksimal_karakter: "50 Karakter",
                        aturan_penulisan: "Terdiri dari huruf <br> Hanya boleh diisi dengan jenis obat yang terdaftar dilist"
                    },
                    {
                        nama_kolom: "HARGA",
                        keterangan: "WAJIB DIISI",
                        maksimal_karakter: "ANGKA",
                        aturan_penulisan: "Terdiri dari angka tanpa pemisah ribuan, boleh menuliskan 0. <br> Contoh: 90000, 100000."
                    },
                    {
                        nama_kolom: "STOK",
                        keterangan: "TIDAK WAJIB DIISI",
                        maksimal_karakter: "ANGKA",
                        aturan_penulisan: "Terdiri dari angka tanpa pemisah ribuan, tidak boleh desimal, boleh menuliskan 0. <br> Contoh: 100."
                    },
                    {
                        nama_kolom: "SATUAN",
                        keterangan: "TIDAK WAJIB DIISI",
                        maksimal_karakter: "-",
                        aturan_penulisan: "Terdiri dari huruf <br> Hanya boleh diisi dengan satuan yang terdaftar dilist"
                    },
                    {
                        nama_kolom: "CATATAN",
                        keterangan: "TIDAK WAJIB DIISI",
                        maksimal_karakter: "-",
                        aturan_penulisan: "Terdiri dari huruf dan angka. Dapat menggunakan simbol. <br> Contoh: Expired Date: 20 September 2030"
                    },
                ],
                progressBar: false,
                barVal: 0,
                barMax: 100,
                time: 0,
            }
        },
        mounted() {
            this.setLoading()
        },
        computed: {
            ...mapGetters(["getKlinikId"]),
            fieldList() {
                return (
                    [
                        {
                            key: "no",
                            label: "",
                            thStyle: "width:5%;background-color:#f4f5fd;color:#639bef;position:-webkit-sticky;position:sticky;top:0px;",
                            thClass: "pt-4 pb-4"
                        },
                        {
                            key: "nama_kolom",
                            label: "Nama Kolom",
                            thStyle: "width:25%;background-color:#f4f5fd;color:#639bef;position:-webkit-sticky;position:sticky;top:0px;",
                            thClass: "pt-4 pb-4"
                        },
                        {
                            key: "keterangan",
                            label: "Keterangan",
                            thStyle: "width:20%;background-color:#f4f5fd;color:#639bef;position:-webkit-sticky;position:sticky;top:0px;",
                            thClass: "pt-4 pb-4"
                        },
                        {
                            key: "maksimal_karakter",
                            label: "Maksimal Karakter",
                            thStyle: "width:20%;background-color:#f4f5fd;color:#639bef;position:-webkit-sticky;position:sticky;top:0px;",
                            thClass: "pt-4 pb-4"
                        },
                        {
                            key: "aturan_penulisan",
                            label: "Aturan Penulisan",
                            thStyle: "width:30%;background-color:#f4f5fd;color:#639bef;text-align:center;position:-webkit-sticky;position:sticky;top:0px;",
                            thClass: "pt-4 pb-4"
                        },
                    ]
                )
            },
        },
        methods: {
            fileChange(event) {
                this.file = event.target.files[0]
                let formData = new FormData()
                formData.append('file', this.file, this.file.name)
                formData.append('klinik_id', this.getKlinikId)

                if(
                    this.file.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
                    this.file.type == 'application/vnd.ms-excel'
                ) {
                    this.fileText = this.file.name

                    //upload file
                    this.upload(formData)
                } else {
                    this.fileText = "No file selected."
                    this.$refs.fileupload.value = null
                    this.$swal({
                        text: `Format yang dapat diterima adalah excel (xls, xlsx). Silakan cek kembali format data Anda.`,
                        type: "warning",
                        allowOutsideClick: false,
                        confirmButtonText: "OK",
                    })
                }
            },
            async upload(formData) {
                try {
                    this.progressBar = true
                    this.$nextTick(() => {
                        this.$refs['modal-obat'].show()
                    })
                    
                    const res = await this.$axios.post(
                        `klinik/obat/check-excel?klinik_id=${this.getKlinikId}`, formData, {
                            headers : {
                                "Content-Type": "multipart/form-data"
                            },
                            onUploadProgress: function( progressEvent ) {
                                let progressVal = parseInt( Math.round((progressEvent.loaded / progressEvent.total) * 100))

                                this.barVal = progressVal >= 90 ? 90 : progressVal
                                this.time = parseInt( progressEvent.timeStamp / (60 * 10000) )
                            }.bind(this)
                        }
                    );
                    const { status, data } = res.data

                    if(status && data.row == 0) {
                        this.fileText = "No file selected."
                        this.$refs.fileupload.value = null
                        this.$swal({
                            text: `Data obat kosong! Silakan isi file excel kemudian upload data obat kembali.`,
                            type: "warning",
                            allowOutsideClick: false,
                            confirmButtonText: "OK",
                        })
                    } else if (status && data.is_limit) {
                        this.$swal({
                            text: `Jumlah data Anda melebihi dari jumlah yang ditetapkan (maks. 500 data/baris). Sisa data lainnya tidak akan tersimpan dalam sistem. Lanjutkan upload? `,
                            type: "warning",
                            showCancelButton: true,
                            cancelButtonText: startCase("tidak"),
                            confirmButtonText: startCase("ya")
                        }).then(r => { 
                            if (r.value) {
                                this.barVal = 100;
                                this.$store.commit("SET_UPLOAD_OBAT", data);
                                this.$router.push({name : 'klinik-obat-list-upload'});
                            } else {
                                this.fileText = "No file selected."
                                this.$refs.fileupload.value = null
                            }
                        });
                    } else if(status) {
                        this.barVal = 100;
                        await new Promise(resolve => setTimeout(resolve, 2000));
                        this.$store.commit("SET_UPLOAD_OBAT", data);
                        this.$router.push({name : 'klinik-obat-list-upload'});
                    } else {
                        this.fileText = "No file selected."
                        this.$refs.fileupload.value = null
                        this.$swal({
                            text: `Template tidak sesuai! Silakan gunakan template yang telah disediakan dengan menekan tombol ‘Download Template’.`,
                            type: "warning",
                            allowOutsideClick: false,
                            confirmButtonText: "OK",
                        })
                    }
                } catch (err) {
                    this.fileText = "No file selected."
                    this.$refs.fileupload.value = null
                    this.$swal({
                        text: `Template tidak sesuai! Silakan gunakan template yang telah disediakan dengan menekan tombol ‘Download Template’.`,
                        type: "warning",
                        allowOutsideClick: false,
                        confirmButtonText: "OK",
                    })
                } finally {
                    this.beingSubmit = false
                    this.progressBar = false
                    this.$refs['modal-obat'].hide()
                }
            },
            downloadTemplate() {
                const url = window.location.origin + '/file/Template-Data-Obat.xlsx';
                const fileName = 'Template-Data-Obat.xlsx'
                
                let el = document.createElement('a');
                el.setAttribute('href',url);
                el.setAttribute('download',fileName);
                document.body.appendChild(el);
                el.click()
                document.body.removeChild(el);
            },
            setLoading() {
                this.$store.commit("SET_LOADING", true);

                setInterval(() => {
                    this.$store.commit("SET_LOADING", false);
                }, 1000)
            },
        }
    };
</script>

<style lang="scss">
    .table-striped > tbody > tr:nth-child(2n+1) > td, .table-striped > tbody > tr:nth-child(2n+1) > th {
        background-color: #f9f9f9;
    }
    .card-bg {
        background-color : #e9e9e9
    }
    .f-9 {
        font-size: 9px;
    }
    .f-12 {
        font-size: 12px;
    }
    .f-20 {
        font-size: 20px;
    }
    .a-color {
        color: #3b3e66;
    }
    .btn-download {
        background-color: #b681fd !important;
        border-color: #b681fd !important;
        color: #ffffff !important;
        font-weight: bold;
        border-radius: 0.5em;
    }
    .btn-download:hover {
        background-color: #ac74fc !important;
        border-color: #ac74fc !important;
        color: #ffffff !important;
    }
    .upload-btn-wrapper {
        position: relative;
        overflow: hidden;
        display: inline-block;
    }
    .btn-file {
        background-color: #639bef;
        border-color: #639bef;
        color: #ffffff;
        font-weight: bold;
        font-size: 12px;
        border-radius: 0.5em;
        padding: 5px;
    }
    .upload-btn-wrapper input[type=file] {
        font-size: 100px;
        position: absolute;
        left: 0;
        top: 0;
        opacity: 0;
    }
    .progress-bar {
        background-color: #3d8bef !important;
    }
    .modal-body {
        padding: 2.5rem 3rem 5rem 3rem !important;
    }
</style>
